module.exports = __webpack_public_path__ + "img/8.0070d3f2.png";